import { useGlobalLoadingState } from '../context/GlobalLoadingStateContext';
import { useAppSelector } from '../reducers';
import { isAppReadySelector } from '../selectors/LoadingStateSelectors';
import { useIsInAppAuth } from '../v2/hooks/user/useUserInfo';
export const useGlobalLoading = () => {
  const isPurchaseOptionsLoading = useGlobalLoadingState('PurchaseOptions');
  const isInApp = useIsInAppAuth();
  return useAppSelector(isAppReadySelector({
    isPurchaseOptionsLoading,
    isInApp
  }));
};